import { createContext, useContext } from 'react';

// Read by ChatMessage/JourneyContent. Holds NO default journey deliberately — see
// .claude/context/journeys.md's "Why JourneyContext holds no default journey".
export const JourneyContext = createContext(null);

export const useJourney = () => {
  const journey = useContext(JourneyContext);
  if (journey === null) {
    throw new Error('useJourney must be used within a JourneyProvider');
  }
  return journey;
};
